import { ajax } from 'gkSrc/utils/request'

import store from '@/store'
import config from '@/config'
import { login } from '@geekbang/time.sdk'

// 自定义 headers
const customHeaders = {
  'Content-Type': 'application/json'
}

/**
 * 请求方法
 * @see 请求参数详细信息查看 gkuiRequest.js 文件
 * @param {Object} options
 * @param {Object} [options.appConfig]    调用客户端发起的请求时，需要的一些配置参数
 */
function request (options = {}) {
  options.withCredentials = true
  options.headers = options.headers || customHeaders
  options.host = options.host || config.baseHost

  return ajax(options).then(res => {
    return res
  }).catch(err => {
    // 需要登录的接口，未登录时自动跳转到登录页面
    try {
      if (err.api === 1) {
        // 需要登录的接口，在未登录时的错误
        if (options.signin && (err.code === -2000 || err.code === -1004 || err.code === -3050)) {
          login()
        }
      } else {
        if (err.error.response.status === 452 || err.error.response.status === 451 || err.error.response.status === 401) {
          store.dispatch('logout')
        }

        // 业务错误
        if (err.error.response.status === 400) {
          let { code, error = {} } = err.error.response.data

          code = error.code || code

          err.api = 1
          err.code = code | 0
          err.message = error.msg || ''
        }
      }
    } catch (error) {
      console.log(error)
    }

    return Promise.reject(err)
  })
}

export default request
